import { Directive, Input, ElementRef, OnInit } from '@angular/core';

@Directive({
    selector: '[capAutofocus]',
    standalone: true
})
export class AutofocusDirective implements OnInit {
  @Input('capAutofocus') shouldFocus: boolean;

  constructor(private el: ElementRef) {}

  ngOnInit() {
    if (this.shouldFocus) {
      setTimeout(() => {
        this.el.nativeElement.focus();
      }, 0);
    }
  }
}
